/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
export var SendETH = createPlugin({
    protocol: 'UTILITY',
    type: 'ACTION',
    description: 'Send ETH',
    method: '',
    name: 'sendETH',
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            value: new FctValue({ destination: 'wei_amount' }),
            methodParams: {},
        },
        output: {},
    }); },
    initParams: {},
});
